import util from './util'

let UpArrow = Vue.component('up-arrow', {
	props: ['title'],
	methods: {
		onArrowClick() {
			if (this.$store.state.loopHelper.fixOutro) {
				util.scrollToPosition($(document).height() - $(window).height() * 2)
				this.$store.commit('')
				return
			}
			util.scrollToPosition(0)
		},
		flash() {
			if (this.$store.state.loopHelper.fixOutro) {
				return
			}
			this.$nextTick(() => {
				this.flashArrow = true
			})
			setTimeout(() => {
				this.flashArrow = false
			}, 1000);
		},
		onMouseEnter() {
			if (this.$store.state.loopHelper.fixOutro) {
				return
			}
			this.$nextTick(() => {
				this.flashArrow = true
			})
		},
		onMouseLeave() {
			if (this.$store.state.loopHelper.fixOutro) {
				return
			}
			this.$nextTick(() => {
				this.flashArrow = false
			})
		}
	},
	data() {
		return {
			text: this.$store.state.currentMenuItem.title,
			flashArrow: false
		}
	},
	computed: {
		computedTitle() {
			this.text = this.$store.state.currentMenuItem.title
			return this.text.split('')
		},
		classes() {
			return {
				'up-arrow--hidden': !this.$store.state.loopHelper.showUpArrow,
				'up-arrow--flash': this.flashArrow
			}
		}
	},
	mounted() {
		$(window).on('resize', () => {
			this.$forceUpdate()
		})
	},
	template: `
		<div class="up-arrow" :class="classes" :style="this.$root.largeTypoScaling" @click="onArrowClick" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
			<span class="up-arrow-arrow">&#8613;</span>
			<ul class="up-arrow-title">
				<li v-for="character in computedTitle">{{ character }}</li>
			</ul>
		</div>`
})

export default UpArrow
